import React from "react";
import Monogram from "../../Assets/Monogram.png";

function Pre(props) {
  return (
    <div id={props.load ? "preloader" : "preloader-none"}>
      <img
        src={Monogram}
        alt="EK Logo"
        className="fixed top-[40%] left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-10 h-10 animate-[fadeIn_0.5s_ease-in]"
      />
    </div>
  );
}

export default Pre;
